module.exports = __webpack_public_path__ + "svg/countdown-spacer.svg";